<template>
  <div
      class="question-multipart-wrapper d-flex flex-wrap align-items-end"
  >
    <QuestionBase
        :question="question"
        :valid="!!data"
        :errors="[...serverErrors, ...jsErrors]"
    >
      <InputDateSplit
          v-if="data || data === null"
          v-model="data" :db="db"
          :args="args"
          :skipped="skipped"
          @skipped="skipped=$event"
          @serverErrors="serverErrors=$event"
          @jsErrors="jsErrors=$event"
      />
    </QuestionBase>
  </div>
</template>

<script>
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";
import {saveHelpers} from "@/views/questionnaires/saveHelpers";

import QuestionBase from "../../../QuestionBase";
import InputDateSplit from "../../../inputs/InputDateSplit";

export default {
  name: 'VisaExpiry',
  mixins: [saveHelpers, questionLoadHelpers],
  components: {
    InputDateSplit,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    },
    saveLocation: {
      type: String,
      default: 'client_client'
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    }
  },
  data() {
    return {
      question: {
        title: 'When is your VISA due to expire?',
        subTitle: null,
        tip: null
      },
      db: {
        saveLocation: this.saveLocation,
        saveField: 'profileVisaExpiry'
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
